import { Grid, IconButton } from '@material-ui/core'
import { CloseIcon } from 'components/facets'
import { useUser } from 'components/providers/UserProvider'
import { getPtArticleLocations } from 'lib/api'
import _ from 'lodash'
import { useEffect, useState } from 'react'
import Accordion from 'react-bootstrap/Accordion'
import { getDisplayLocationName, InventoryArticle, Location } from 'shared'
import { VisualArticle } from '../StockDisplay/VisualArticle'

export interface ReservedQuantityReportDrawerProps {
  article: InventoryArticle
  onClose: () => void
}

export const ReservedQuantityReportDrawer = ({
  article,
  onClose,
}: ReservedQuantityReportDrawerProps): JSX.Element => {
  const { user } = useUser()
  const [locations, setLocations] = useState<Location[]>([])
  const [currentInventoryArticle, setCurrentInventoryArticle] = useState<InventoryArticle>()

  const fetchLocations = async () => {
    try {
      const locationsData = await getPtArticleLocations(article.locations![0].ptArticleId, true)
      const currentVisualArticle = _.cloneDeep(article)
      currentVisualArticle.quantity = locationsData
        .filter((loc) => getDisplayLocationName(loc.name) !== 'Unknown')
        .reduce((acc, loc) => acc + loc.quantity, 0)
      setCurrentInventoryArticle(currentVisualArticle)
      setLocations(locationsData)
    } catch (error) {
      console.error('Error fetching locations:', error)
    }
  }

  const displayPickedQuantity = (pickedQ: number) => {
    if (pickedQ === undefined || pickedQ === 0) {
      return <span>0 or Unknown</span>
    }
    return <span>{pickedQ}x</span>
  }

  useEffect(() => {
    fetchLocations()
  }, [])

  return (
    <div className="price-suggest-presenter-container">
      <div className="px-3 py-1">
        <div className="d-flex justify-content-start">
          <IconButton onClick={onClose} data-testid="close-reserved-quantity">
            <CloseIcon />
          </IconButton>
        </div>
        {currentInventoryArticle && (
          <div>
            <h5 className="fw-semibold px-3">
              {article.card.name} {article.card.set}
            </h5>
            <div className="mx-auto">
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <div>
                    <div className="mb-3">
                      <VisualArticle
                        visualArticleSizeClass="three"
                        rowHeight={250}
                        article={currentInventoryArticle!}
                        currency={user.currency}
                        displayOnly
                      />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div className="p-3 fs-6">
                    <div>
                      <span>Total registered quantity for this product:</span>
                      <span data-testid="registered-quantity">
                        {' '}
                        {currentInventoryArticle.quantity}x
                      </span>
                    </div>
                    <div className="mt-2">
                      <span>Sold quantity and not shipped:</span>
                      <span data-testid="total-reserved-quantity">
                        {' '}
                        {currentInventoryArticle.ptArticleReservedQuantity}x
                      </span>
                    </div>
                  </div>
                </Grid>
              </Grid>
              <div className="mb-5">
                <Accordion defaultActiveKey={['0']} data-testid="locations-accordion">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>Picked quantity per location</Accordion.Header>
                    <Accordion.Body>
                      <div>
                        <table className="table">
                          <tbody>
                            {locations.length > 0 ? (
                              locations.map((location) => (
                                <tr
                                  key={location._id}
                                  data-testid={'picked-quantity-' + location.name}
                                >
                                  <td>
                                    <span className="pe-3">
                                      {getDisplayLocationName(location.name)}:{' '}
                                    </span>
                                  </td>
                                  <td>{displayPickedQuantity(location.totalPickedQuantity!)}</td>
                                </tr>
                              ))
                            ) : (
                              <span>No locations available</span>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
